<div #aaFocus id="aa-focus" [ngClass]="{'aa-focus-visible': focusOutline}"></div>